<span *ngFor="let deco of decorationInfoArray">
    <span *ngIf="deco.displayText && deco.isPlainText"
        [innerHtml]="deco.displayText" 
        [ngClass]="{
            'bold': deco.isBold,
            'strike-through': deco.isStrikeThrough
        }"
    ></span>
    <a *ngIf="deco.displayText && !deco.isPlainText && deco.uiSref"
        [innerHtml]="deco.displayText"
        [ngClass]="{
            'now-btn-link-black': deco.isLink && decorationInfoArray.length === 1,
            'inline-link': deco.isLink && decorationInfoArray.length > 1,
            'now-btn-primary-black': deco.isPrimary,
            'now-btn-secondary-light': deco.isSecondary
        }"
        [target]="deco.newTab ? '_blank' : ''"
        [uiSref]="deco.uiSref"
        [uiParams]="deco.uiParams"
    ></a>
    <a *ngIf="deco.displayText && !deco.isPlainText && deco.absoluteUrl"
        [innerHtml]="deco.displayText"
        [ngClass]="{
            'now-btn-link-black': deco.isLink && decorationInfoArray.length === 1,
            'inline-link': deco.isLink && decorationInfoArray.length > 1,
            'now-btn-primary-black': deco.isPrimary,
            'now-btn-secondary-light': deco.isSecondary
        }"
        [target]="deco.newTab ? '_blank' : ''"
        [href]="deco.absoluteUrl"
    ></a>
</span>
<ng-content></ng-content>
